import { Components, Theme } from '@mui/material';

import { PrimaryColors } from '../constants';
import { formControlStyles } from './MuiFormControl';

export const MuiPickersDay: Components<Theme>['MuiPickersDay'] = {
  styleOverrides: {
    root: {
      ...formControlStyles,
      '&.MuiPickersInputBase-root': {
        fontSize: '16px !important',
      },

      '&.Mui-selected': {
        backgroundColor: PrimaryColors.diamond,
        color: PrimaryColors.black,
        '&:hover': {
          backgroundColor: PrimaryColors.diamond,
        },
      },
      '&.Mui-error': {
        color: PrimaryColors.radical,
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: PrimaryColors.radical,
        },
      },
      '& .MuiFormHelperText-root.Mui-error': {
        color: PrimaryColors.radical,
      },
    },
  },
};
